module.exports = __webpack_public_path__ + "img/negri.6374db44.jpg";